import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-computer-science',
  templateUrl: './computer-science.component.html',
  styleUrls: ['./computer-science.component.scss']
})
export class ComputerScienceComponent implements OnInit {
  constructor() { }
  ngOnInit(): void { }
}
